<template>
  <!-- <div id="app" class="theme-dark" @contextmenu.prevent> -->
  <!-- <div id="app" class="theme-dark"> -->
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'GamanUI',
  data() {
    return {}
  },
}
</script>

<style lang="scss">
$fa-font-path: '~font-awesome/fonts';
// @import '~font-awesome/css/font-awesome.min.css';
@import '~font-awesome/scss/font-awesome.scss';

#app {
  width: 100%;
}
</style>
